export default (livewire) => ({
  init() {
    tinymce.init({
      selector: "#episode-description",
      branding: false,
      menubar: false,
      setup: function (editor) {
        editor.on("init change", function () {
          editor.save();
        });
        editor.on("change", function (e) {
          livewire.set("episode.post_content", editor.getContent(), true);
        });
      },
      plugins: [
        "advlist autolink lists link image charmap print preview anchor textcolor",
        "searchreplace visualblocks code fullscreen",
        "insertdatetime media table contextmenu paste code ",
      ],
      contextmenu:
        "copy | paste | link image inserttable | cell row column deletetable",
      toolbar:
        "formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link",
      content_css: [
        "//fonts.googleapis.com/css?family=Lato:300,300i,400,400i",
        "//www.tinymce.com/css/codepen.min.css",
      ],
    });
  },
  updateEditor() {
    if (tinymce.activeEditor) {
      tinymce.activeEditor.setContent(livewire.get("episode.post_content"));
    }
  },
});
